import gql from 'graphql-tag';

export default gql`
    fragment PlaquePhoto on PlaquePhoto {
        ID
        Caption
        Comment
        File {
            ... on Image {
                ID
                Name
                Size
                AbsoluteLink
            }
            ... on File {
                ID
                Name
                Size
                AbsoluteLink
            }
        }
    }
`;
